import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'vc-show-more-button',
  templateUrl: './show-more-button.component.html',
  styleUrls: ['./show-more-button.component.scss']
})
export class ShowMoreButtonComponent {
  @Input()
  isShowingMore: boolean;
  @Output()
  toggleShowMore = new EventEmitter<boolean>();

  emitToggleShowMore() {
    this.toggleShowMore.emit(true);
  }
}
